import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { useFieldArray, useForm } from 'react-hook-form';
import { InputField, InterestInputField } from 'components/form';

import { DealerTiersPortalConfiguration } from '../types';

interface Props {
  isLoading: boolean;
  defaultValues: DealerTiersPortalConfiguration;
  onConfirm: (configuration: DealerTiersPortalConfiguration) => Promise<void>;
}

export const DealerTiers = ({ isLoading, defaultValues, onConfirm }: Props) => {
  const { control, handleSubmit } = useForm<DealerTiersPortalConfiguration>({
    defaultValues,
  });

  const { fields } = useFieldArray({ control, name: 'tiers' });

  return (
    <>
      <Stack gap="1rem" flex={1}>
        {fields.map((field, index) => (
          <Stack key={field.id} direction="row" gap="0.5rem" alignItems="flex-start">
            <InputField
              label="Title"
              control={control}
              name={`tiers.${index}.label`}
              inputProps={{
                disabled: true,
              }}
            />

            <InterestInputField
              decimalScale={2}
              control={control}
              allowNegative={false}
              label="Dealer Subsidy Contribution"
              name={`tiers.${index}.dealerSubsidyContribution`}
              isAllowed={({ floatValue }) => floatValue === undefined || (floatValue >= 0 && floatValue <= 100)}
            />
          </Stack>
        ))}
      </Stack>

      <Box mt="1rem">
        <Button loading={isLoading} variant="contained" onClick={handleSubmit(onConfirm)}>
          Save
        </Button>
      </Box>
    </>
  );
};
